export enum MessageOriginEnum {
	USER=0,
	BOT=1,
}

export const MessageOriginFromIndex: {[id: number]: MessageOriginEnum} = {
	0: MessageOriginEnum.USER,
	1: MessageOriginEnum.BOT,
};
export default MessageOriginEnum;
